import { formatNumber } from "@";

const ChartTooltip = ({ active, payload, label, legendItems }) => {
  if (active && payload && payload.length) {
    return (
      <div
        dir="rtl"
        className="rounded-2xl border bg-white px-3 py-2 text-sm font-semibold text-gray-500 shadow-sm transition-opacity duration-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
      >
        <strong>{label}</strong>
        {payload.map((item, index) => (
          <p key={index}>
            <span className="me-2">{legendItems?.[index].name}:</span>
            <strong className="inline-block">
              {formatNumber(item.value?.toFixed(2))}%
            </strong>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default ChartTooltip;
